var map = {
	"./categories_engagement_mobile_all@2x.webp": 1678,
	"./categories_memoire_mobile_all@2x.webp": 1679,
	"./color_gold_a-2230-1@2x.webp": 1718,
	"./color_multicolor_a-1629-3@2x.webp": 1719,
	"./color_platinum_a-2130-1@2x.webp": 1720,
	"./color_redgold_a-2111-1@2x.webp": 1721,
	"./color_rosegold_a-1755-1@2x.webp": 1722,
	"./color_signature_a-1598-6@2x.webp": 1723,
	"./color_whitegold_a-1939-8@2x.webp": 1724,
	"./customer_design_10@2x.webp": 1725,
	"./customer_design_1@2x.webp": 1726,
	"./customer_design_2@2x.webp": 1727,
	"./customer_design_3@2x.webp": 1728,
	"./customer_design_4@2x.webp": 1729,
	"./customer_design_5@2x.webp": 1730,
	"./customer_design_6@2x.webp": 1731,
	"./customer_design_7@2x.webp": 1732,
	"./customer_design_8@2x.webp": 1733,
	"./customer_design_9@2x.webp": 1734,
	"./endless_possibilities@2x.webp": 378,
	"./impressive_jewelry@2x.webp": 1680,
	"./individual_weddingrings@2x.webp": 377,
	"./individual_weddingrings_ring@2x.webp": 1735,
	"./individual_weddingrings_ring_1@2x.webp": 1736,
	"./individual_weddingrings_ring_2@2x.webp": 1737,
	"./individual_weddingrings_ring_3@2x.webp": 1738,
	"./individual_weddingrings_ring_4@2x.webp": 1739,
	"./individual_weddingrings_ring_5@2x.webp": 1740,
	"./individual_weddingrings_spread@2x.webp": 1741,
	"./information_ethical@2x.webp": 1681,
	"./information_ethical_mob@2x.webp": 1682,
	"./information_inspiring_design@2x.webp": 1683,
	"./information_inspiring_design_mob@2x.webp": 1684,
	"./information_message_of_love@2x.webp": 1685,
	"./information_message_of_love_mob@2x.webp": 1686,
	"./inspiration_01@2x.webp": 1691,
	"./inspiration_02@2x.webp": 1692,
	"./inspiration_03@2x.webp": 1693,
	"./inspiration_04@2x.webp": 1694,
	"./inspiration_05@2x.webp": 1695,
	"./inspiration_06@2x.webp": 1696,
	"./inspiration_collections@2x.webp": 1677,
	"./inspiration_styles@2x.webp": 1676,
	"./inspiring_background@2x.webp": 1748,
	"./inspiring_background_mobile@2x.webp": 1749,
	"./inspiring_background_parallax@2x.webp": 1750,
	"./magazine@2x.webp": 1751,
	"./ring_a-2097@2x.webp": 1688,
	"./ring_memoires@2x.webp": 1689,
	"./signature_background_desktop@2x.webp": 1752,
	"./signature_background_mobile@2x.webp": 1753,
	"./world_of_acredo@2x.webp": 1754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3259;